/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SamlGenerateEntityIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type SamlGenerateEntityIdMutation = { __typename: 'Mutation', ssoProviderSamlGenerateEntityId: { __typename: 'Sso', id: string, domain: string, verificationStatus: Types.DomainVerificationStatus, provider?: { __typename: 'OidcProvider', strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'OidcOptions', clientId?: string | null } } | { __typename: 'SamlProvider', strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'SamlOptions', entityId?: string | null } } | null } };


export const SamlGenerateEntityIdDocument = gql`
    mutation SamlGenerateEntityId($id: ID!) {
  ssoProviderSamlGenerateEntityId(input: {id: $id}) {
    id
    domain
    verificationStatus
    provider {
      ... on SsoProviderInterface {
        strategy
        validationStatus
      }
      ... on OidcProvider {
        options {
          clientId
        }
      }
      ... on SamlProvider {
        options {
          entityId
        }
      }
    }
  }
}
    `;
export type SamlGenerateEntityIdMutationFn = ApolloReactCommon.MutationFunction<SamlGenerateEntityIdMutation, SamlGenerateEntityIdMutationVariables>;

/**
 * __useSamlGenerateEntityIdMutation__
 *
 * To run a mutation, you first call `useSamlGenerateEntityIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSamlGenerateEntityIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [samlGenerateEntityIdMutation, { data, loading, error }] = useSamlGenerateEntityIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSamlGenerateEntityIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SamlGenerateEntityIdMutation, SamlGenerateEntityIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SamlGenerateEntityIdMutation, SamlGenerateEntityIdMutationVariables>(SamlGenerateEntityIdDocument, options);
      }
export type SamlGenerateEntityIdMutationHookResult = ReturnType<typeof useSamlGenerateEntityIdMutation>;
export type SamlGenerateEntityIdMutationResult = ApolloReactCommon.MutationResult<SamlGenerateEntityIdMutation>;
export type SamlGenerateEntityIdMutationOptions = ApolloReactCommon.BaseMutationOptions<SamlGenerateEntityIdMutation, SamlGenerateEntityIdMutationVariables>;